import { useMemo, useState } from "react";
import { Announcement } from "Types";
import { useGetAnnouncementsQuery } from "../services/announcements.api";
import { getAnnouncementsSeen, storeAnnouncementSeen } from "../utils";

function filterAnnouncements(
  announcements: Announcement[],
  seenAnnouncementIds: string[],
) {
  return announcements.filter(
    (announcement) =>
      !seenAnnouncementIds.includes(announcement.announcementId),
  );
}

const useAnnouncements = () => {
  const { data: { announcements } = {} } = useGetAnnouncementsQuery();
  const [seenAnnouncementIds, setSeenAnnouncementIds] =
    useState<string[]>(getAnnouncementsSeen);
  const unseenAnnouncements = useMemo(
    () => filterAnnouncements(announcements || [], seenAnnouncementIds),
    [announcements, seenAnnouncementIds],
  );

  const dismissAnnouncement = (id: string) => {
    storeAnnouncementSeen(id);
    setSeenAnnouncementIds((previous) => [...previous, id]);
  };

  return { unseenAnnouncements, dismissAnnouncement };
};

export default useAnnouncements;
